export const sortByAsc = <T = any>(f: (x: T) => string | number) => {
	return (a: T, b: T): number => {
		if (f(a) < f(b)) { return -1; }
		if (f(a) > f(b)) { return 1; }
		return 0;
	};
};

export const sortByDesc = <T = any>(f: (x: T) => string | number) => {
	return (a: T, b: T): number => {
		if (f(a) < f(b)) { return 1; }
		if (f(a) > f(b)) { return -1; }
		return 0;
	};
};